import type { DemoStoreData } from './store-types';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export interface HandlerContext {
  readonly method: HttpMethod;
  readonly path: string;
  readonly match: RegExpMatchArray;
  readonly query: URLSearchParams;
  readonly body: unknown;
  readonly headers: Record<string, string>;
}

export interface HandlerResult<T = unknown> {
  readonly status: number;
  readonly body: T;
}

export interface Mutator<T> {
  (data: DemoStoreData): { next: DemoStoreData; result: T };
}

export type HandlerReturn<T = unknown> =
  | T
  | HandlerResult<T>
  | { readonly mutate: Mutator<T> }
  | { readonly error: { status: number; message: string } };

export interface HandlerEntry {
  readonly method: HttpMethod;
  readonly pattern: RegExp;
  readonly handle: (ctx: HandlerContext, data: DemoStoreData) => HandlerReturn;
}

export function route(
  method: HttpMethod,
  pattern: RegExp,
  handle: HandlerEntry['handle'],
): HandlerEntry {
  return { method, pattern, handle };
}

export function findRoute(
  entries: readonly HandlerEntry[],
  method: string,
  path: string,
): { entry: HandlerEntry; match: RegExpMatchArray } | null {
  for (const entry of entries) {
    if (entry.method !== method) continue;
    const m = entry.pattern.exec(path);
    if (m) return { entry, match: m };
  }
  return null;
}
